import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerPuntoControl = styled(motion.div)`
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 40px;
  padding: 30px 20px;

  span {
    text-align: center;
    font-size: 20px;
    font-weight: 400;
  }
  
  img {
    width: 180px;
    height: 180px;
    object-fit: contain;
  }
  
  .danger {
    width: 211px;
    height: 49px;
    background: var(--color-danger);
    border-radius: 8px;
    font-size: 18px;
    color: var(--color-white);
    margin-top: 20px;
  }
  
  @media (max-height: 700px) {
    gap: 30px;
    padding: 25px 20px;
    
    img {
      width: 150px;
      height: 150px;
    }
    
    span {
      font-size: 18px;
    }
  }
  
  @media (max-height: 600px) {
    gap: 25px;
    padding: 20px 15px;
    
    img {
      width: 120px;
      height: 120px;
    }
    
    span {
      font-size: 16px;
    }
    
    .danger {
      height: 44px;
      font-size: 16px;
    }
  }
`;
